import { render } from "./comp-info-input.vue?vue&type=template&id=2d460054&scoped=true"
import script from "./comp-info-input.vue?vue&type=script&lang=js"
export * from "./comp-info-input.vue?vue&type=script&lang=js"

import "./comp-info-input.vue?vue&type=style&index=0&id=2d460054&scoped=true&lang=css"

import exportComponent from "D:\\work\\kaifengzimaoqu\\wt_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d460054"]])

export default __exports__